import { combineReducers } from "redux";
import Types from "../../actions/Types";

const list = (state = [], action) => {
  switch (action.type) {
    case Types.GET_USER_GROUPS:
      return action.payload;
    default:
      return state;
  }
};

const remove = (state = [], action) => {
  switch (action.type) {
    case Types.DELETE_USER_GROUP:
      return [...state, { ...action.payload }];
    default:
      return state;
  }
};

export const upsert = (state = [], action) => {
  switch (action.type) {
    case Types.UPSERT_USER_GROUP:
      return [...state, { ...action.payload }];
    default:
      return state;
  }
};
const userGroupReducer = combineReducers({
  upsert,
  remove,
  list,
});

export default userGroupReducer;
